module.exports = __webpack_public_path__ + "img/ryzz.3f82d530.png";